import { BasicTrackingEvent } from "./BasicTrackingEvent";

export class MobileDeviceInformationTrackingEvent extends BasicTrackingEvent {
    public static STAGE3D_NOT_SUPPORTED: string = "stage3DNotSupported";
    public static TYPE_REGISTER: number = 1;
    public static TYPE_LOGIN: number = 2;
    public static TYPE_INSTALL: number = 3;

    public playerId: number = -1;
    public accountID: string = "-1";
    public trackType: number;
    public store: number;
    public deviceInfo: string;
    public deviceID: number;
    public context3DProfile: string = MobileDeviceInformationTrackingEvent.STAGE3D_NOT_SUPPORTED;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};
        vars.playerId = this.playerId;
        vars.var_1 = this.trackType;
        vars.var_2 = this.accountID;
        vars.var_3 = this.store;
        vars.var_4 = this.deviceID;
        vars.var_data = this.deviceInfo;
        return vars;
    }
}
